import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, PropType, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QRCodeCanvas',
  props: {
  urlProvider: {
    type: Function as PropType<() => string>,
    required: true
  },
  qrCodeLib: {
    type: Object as PropType<{
      toCanvas: (canvas: HTMLCanvasElement, url: string) => Promise<void>;
    }>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const qrcodeCanvas = ref<HTMLCanvasElement>();

const renderQRCode = () => {
  if (qrcodeCanvas.value) {
    props.qrCodeLib.toCanvas(qrcodeCanvas.value, props.urlProvider());
  }
};

onMounted(() => {
  renderQRCode();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("canvas", {
      ref_key: "qrcodeCanvas",
      ref: qrcodeCanvas
    }, null, 512)
  ]))
}
}

})